let data: any = localStorage.getItem('userData')
let dataJson = JSON.parse(data)
let userData: any = dataJson || {
    id: "",
    department_id: "",
    position_id: "",
    position_name: "",
    top_menu_list: [],
    left_menu_list: []
}

// 首页不需要做过滤
userData.top_menu_list.unshift({
    id: "1",
    name: "首页",
    p_id: "",
    level_type: 2,
    menu_type: 3,
    url: "",
    route_url: "/",
    order_num: 1,
    children: [],
})

userData.left_menu_list.unshift({
    id: "8",
    name: "首页",
    p_id: "1",
    level_type: 2,
    menu_type: 2,
    url: "",
    route_url: "",
    order_num: 1,
    children: [
        {

            id: "9",
            name: "概览",
            p_id: "8",
            level_type: 2,
            menu_type: 2,
            url: "",
            route_url: "/",
            order_num: 1,
            children: null
        },
        {

            id: "10",
            name: "个人信息",
            p_id: "8",
            level_type: 2,
            menu_type: 2,
            url: "",
            route_url: "/user_info",
            order_num: 2,
            children: null
        },
    ]
})

export default userData